import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {GridComponent} from './grid/grid.component';
import {ActivatedRoute, Data} from '@angular/router';
import {ReportComponent} from '../../../shared/components/report/report.component';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ReportStore} from '../../../shared/store/report/report.store';
import {ReportDashboardStore} from '../../../shared/store/report/report-dashboard.store';
import {DashboardWidget} from '../../../shared/store/report/report-dashboard';
import {ReportParamsStore} from '../../../shared/store/report/report-params.store';
import {AppState} from '../../../shared/store/store';
import {Store} from '@ngrx/store';
import {PublicReportData} from '../../../shared/store/publicReports/public-reports';
@Component({
  selector: 'app-dashboard-report',
  templateUrl: './dashboard-report.component.html',
  styleUrls: ['./dashboard-report.component.scss'],
  providers: [
    ReportStore,
    ReportParamsStore,
    ReportDashboardStore
  ]
})
export class DashboardReportComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(GridComponent)   public readonly gridC: GridComponent;
  @ViewChild(ReportComponent) public readonly reportC: ReportComponent;

  @Input('publicReportData') set setReport(publicReportData: PublicReportData | null | undefined) {
    if (publicReportData) {
      this._reportStore.initPublicReport(
        publicReportData.report,
        publicReportData.uuid,
        publicReportData.token
      );
    }
  };

  public readonly initialized$: Observable<boolean> = this._reportStore.initialized$;
  public readonly iframe$: Observable<boolean> = this._route.data.pipe(map((data: Data): boolean => data.iframe || false));
  public readonly publicMode$: Observable<boolean> = this._reportStore.publicMode$;
  public readonly dashboard$: Observable<Array<DashboardWidget>> = this._reportDashboardStore.dashboard$;

  constructor(
    private readonly _route: ActivatedRoute,
    private readonly _store: Store<AppState>,
    private readonly _reportStore: ReportStore,
    private readonly _reportDashboardStore: ReportDashboardStore
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  public onFullscreen(): void {
    this.gridC.updateSize();
  };

  public onAddWidget(): void {
    this._reportDashboardStore.configureAddWidget();
  }

  public onMoveWidgets(): void {
    this._reportDashboardStore.configureMoveWidgets();
  }

  public resize(): void {
    this.gridC.updateSize();
  }

  public disableAddWidgetButton(): boolean {
    if (!this.gridC || !this.gridC.gridsterC) return false;

    return this.gridC.gridsterC.rows >= 2000;
  }
}
